import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, loading } = useAuth();
	if (loading) {
		return <></>; // Show loading screen while checking auth
	}
	return isAuthenticated ? (
		children
	) : (
		<Navigate
			to={`/login${window.location.search || "?"}&redirect=${
				window.location.pathname
			}`}
			// replace
		/>
	);
};

export default ProtectedRoute;
